(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.documentCard = {
    attach: function (context, settings) {

      $(once('document-card', '.document', context)).each(function () {
        const $card = $(this);
        const $pdfLink = $card.find('a.btn.purple');
        const $tempLink = $card.find('a.btn.temp');
        const $otherLinks = $card.find('a.btn').not($pdfLink).not($tempLink);

        // hide link buttons if temp link exists
        if ($tempLink.length) {
          $pdfLink.hide();
          $otherLinks.hide();
          $otherLinks.closest('.field__item').hide();
        }
      });
    }
  };

})(jQuery, Drupal);